import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import { initPostHog } from './config/posthog.config';

// Initialize PostHog (only in production or if explicitly enabled in dev)
initPostHog();

const rootElement = document.getElementById('root');
if (!rootElement) throw new Error('Root element not found');
const root = ReactDOM.createRoot(rootElement);

root.render(<App />);
